import { PricedVariant } from '@medusajs/medusa/dist/types/pricing'

export const canBuy = (variant: PricedVariant) => {
    return (variant.inventory_quantity && variant.inventory_quantity > 0) || variant.allow_backorder || false
}
